import React, {
    useState,
    FormEvent,
} from 'react';

import NServer from "../components/NServer";
import { Storage } from '@capacitor/storage';
import { PlayInstallReferrer } from "@ionic-native/play-install-referrer";
import { isPlatform } from '@ionic/react';


import { 
    IonContent, 
    IonHeader, 
    IonPage, 
    IonTitle, 
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonLabel,
    IonInput,
    IonButton,
    InputCustomEvent, 
    NavContext,
    IonText,
    useIonRouter,
    useIonViewWillEnter,
    IonLoading
} from '@ionic/react';

import { LANGUAGE, GetStr, GetLanguage } from "../language/Language";
import { hideTab } from "../components/Tabs";
import { showAlert } from '../components/Alert';

import './Main.css';

type FormErrors = {
    email : string;
    password : string;
    confirmPassword : string;
    referral : string;
};

type RegisterProps = {
    email : string;
    password : string;
    confirmPassword : string;
    referral : string;
    lang : string;
    formErrors : FormErrors,
    emailValid : boolean,
    passwordValid : boolean,
    confirmPasswordValid : boolean;
    formValid : boolean
};

const CryptoJS = require("crypto-js");

const Register : React.FC = () => 
{
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [referral, setReferral] = useState("-");

    const [emailValid, setEmailValid] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);
    const [confirmValid, setConfirmValid] = useState(false);
    
    const [showLoading, setShowLoading] = useState(false);

    //	Initializing our router
	const router = useIonRouter();    
    
    useIonViewWillEnter(() => {
        LoadInstallParams();
        hideTab();
    });

    const LoadInstallParams = async () => {
        var server = new NServer();
        var osType = "apk";
        if (isPlatform("ios"))
            osType = "app";

        await server.getList("referrer_install", { type: osType });

        if (server.success)
        {
            const d = server.data;
            
            // set data
            setReferral(d.referral);
        }
    }

    // registration success
    const registerSuccess = () => {
        router.push('/confirm_email', 'back', 'pop');
    }

    // when form submit
    const submit = async () => {
        
        setShowLoading(true);

        const state = {
            email: email,
            password: password,
            confirmPassword: confirm,
            referral: referral
        }

        var server = new NServer();
        await server.sendForm("register", state);
        
        setShowLoading(false);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // move to confirm page
            var id = server.data.id;
            var key = server.data.tempkey;
              
            const setTempID = async () => { 
                await Storage.set({
                    key: 'temp_id',
                    value: '' + id,
                });
            };

            const setTempKey = async () => {
                await Storage.set({
                    key: 'temp_key',
                    value: key,
                });
            };

            await setTempID();
            await setTempKey();

            registerSuccess();
        }
    }

    // change the email
    const changeEmail = (e : any) => {
        let emailVal = e.detail.value.toString();
        setEmail(emailVal);
        setEmailValid(emailVal.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) != null);
    }

    // change the password
    const changePassword = (e : any) => {
        let psw = e.detail.value.toString();
        setPassword(psw);
        setPasswordValid(psw.length >= 8);
    }

    // change the confirmation password
    const changeConfirm = (e : any) => {
        let confirmPwd = e.detail.value.toString();
        setConfirm(confirmPwd);
        setConfirmValid(confirmPwd == password);
    }

    // check whether inputs are valid or not
    const inputValid = () : boolean => {
        return emailValid && passwordValid && confirmValid;
    }

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="transparent">
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="login" />
                    </IonButtons>
                </IonToolbar>
                <IonLoading
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
                />
                <IonGrid>
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-lg="8" size="12">
                            <h3 className="title"><IonText>{ GetStr(LANGUAGE.TXT_REGISTER_TITLE) }</IonText></h3>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-lg="8" size="12">
                            <div className="center-flex">
                                <IonGrid className="ion-no-margin">
                                    <IonRow>
                                        <IonCol>
                                            <IonItem color="none">
                                                <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_EMAIL) }</IonLabel>
                                                <IonInput name="email" onIonChange={changeEmail} />
                                            </IonItem>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <small>{ GetStr(LANGUAGE.TXT_EMAIL_INFO) }</small>
                                        </IonCol>
                                    </IonRow>    
                                    {
                                        !emailValid && email.length > 4 ?
                                    <IonRow>
                                        <IonCol>
                                            <IonText color="danger">{ GetStr(LANGUAGE.TXT_INVALID_EMAIL_FORMAT) }</IonText>
                                        </IonCol>
                                    </IonRow>
                                        :
                                    <div/>
                                    }
                                    <IonRow>
                                        <IonCol>
                                            <IonItem color="none">
                                                <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_PASSWORD) }</IonLabel>
                                                <IonInput type="password" name="password" onIonChange={changePassword} />
                                            </IonItem>
                                        </IonCol>
                                    </IonRow>
                                    {
                                        !passwordValid && password.length > 1 ?
                                    <IonRow>
                                        <IonCol>
                                            <IonText color="danger">{ GetStr(LANGUAGE.TXT_PSW_NOT_8CHAR) }</IonText>
                                        </IonCol>
                                    </IonRow>
                                        :
                                    <div/>
                                    }
                                    <IonRow>
                                        <IonCol>
                                            <IonItem color="none">
                                                <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_CONFIRM_PASSWORD) }</IonLabel>
                                                <IonInput type="password" name="confirmPassword" onIonChange={changeConfirm} />
                                            </IonItem>
                                        </IonCol>
                                    </IonRow>
                                    {
                                        !confirmValid && confirm.length >= 8 ?
                                    <IonRow>
                                        <IonCol>
                                            <IonText color="danger">{ GetStr(LANGUAGE.TXT_CONFIRM_PSW_MATCH) }</IonText>
                                        </IonCol>
                                    </IonRow>
                                        :
                                    <div/>
                                    }
                                    <IonRow className="ion-margin-top">
                                        <IonCol>
                                            <div>{ GetStr(LANGUAGE.TXT_REFERRAL_ID_OPT) }</div>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonItem color="none">
                                                <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_REFERRAL_EMAIL) }</IonLabel>
                                                <IonInput name="referral" value={referral} onIonChange={ (e:any) => { setReferral(e.detail.value.toString()) } }/>
                                            </IonItem>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow className="ion-margin-top">
                                        <IonCol>
                                            <IonButton className="main-but" color="primary" expand="block" onClick={submit} disabled={!inputValid()}>
                                                { GetStr(LANGUAGE.TXT_REGISTER2) }
                                            </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
}


export default Register;